<div class="chip-row-wrapper">
    <hc-chip-row>
        <hc-chip
            *ngFor="let chipInfo of filterChips; trackBy: trackByFn"
            [hasCloseButton]="true"
            [title]="chipTitle(chipInfo)"
            (closeClick)="closeChip(chipInfo)"
        >
            {{ chipLabel(chipInfo) }}
        </hc-chip>
    </hc-chip-row>
    <button
        hc-button
        *ngIf="filterChips.length > 0"
        buttonStyle="link-inline"
        (click)="resetAllFilters.emit()"
        size="sm"
        class="cdp-filter-row-clear-all"
        title="Clear all filters"
    >
        <span class="icon-undo icon-left"></span>
        Reset filters
    </button>
</div>
